import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// ── ERP Context State ──────────────────────────────────────────────────────────
// Holds the active transaction context shown in the ERPContextBar.
// Each page that hosts a transaction document dispatches setErpContext
// after loading the document. clearErpContext should be called on unmount.

export interface ErpContext {
  companyCode:         string;
  companyName:         string;
  locationCode?:       string | null;
  locationName?:       string | null;
  costCenterCode?:     string | null;
  costCenterName?:     string | null;
  financialYearCode:   string;
  financialPeriodCode: string;
  transactionTypeCode: string;
  documentNumber?:     string | null;
  currencyCode:        string;
  exchangeRate:        number;
}

interface ErpContextState {
  context: ErpContext | null;
}

const initialState: ErpContextState = {
  context: null,
};

export const erpContextSlice = createSlice({
  name: 'erpContext',
  initialState,
  reducers: {
    setErpContext: (state, action: PayloadAction<ErpContext>) => {
      state.context = action.payload;
    },
    clearErpContext: (state) => {
      state.context = null;
    },
  },
});

export const { setErpContext, clearErpContext } = erpContextSlice.actions;
export default erpContextSlice.reducer;
